import { render } from "./TextUsIcon.vue?vue&type=template&id=3ae8861a"
import script from "./TextUsIcon.vue?vue&type=script&lang=js"
export * from "./TextUsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__